exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 10;\n  animation: fadeIn 500ms; }\n\n.modal__content {\n  min-width: 260px;\n  max-width: 800px;\n  display: inline-block;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 24px 24px 0 rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 20;\n  text-align: center;\n  padding: 40px; }\n  @media screen and (min-width: 768px) {\n    .modal__content {\n      width: 500px; } }\n\n.modal__header b {\n  color: #15e1d5; }\n\n.modal__children {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column; }\n\n.modal__button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Modal/modal.scss
// module id = 5369
// module chunks = 0